import { render, staticRenderFns } from "./Chatbox.vue?vue&type=template&id=4422ff12&scoped=true"
import script from "./Chatbox.vue?vue&type=script&lang=js"
export * from "./Chatbox.vue?vue&type=script&lang=js"
import style0 from "./Chatbox.vue?vue&type=style&index=0&id=4422ff12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4422ff12",
  null
  
)

export default component.exports